import React from 'react';
import PropTypes from 'prop-types';
import {popupsData} from 'data/popups-facilitator-data';
import {getText} from 'helpers/language-helper';
import Button from 'components/button/button';
import './delete-game-popup.scss';

const DeleteGamePopup = ({isDeletingGame, languageId, gameId, toggleDeleteGamePopup, handleDeleteGame}) => {
	let text = getText(popupsData.deleteGame.text, languageId);
	text = text.replace(/%gameId%/g, gameId);

	return (
		<div className="DeleteGamePopup" onClick={() => {toggleDeleteGamePopup(null);}}>
			<div className="DeleteGamePopup-content" onClick={(e) => {e.stopPropagation();}}>
				<div className="DeleteGamePopup-header">
					<div className="DeleteGamePopup-title">
						{getText(popupsData.deleteGame.title, languageId)}
					</div>
				</div>
				<div className="DeleteGamePopup-body">
					<div className="DeleteGamePopup-text">{text}</div>
					<div className="DeleteGamePopup-buttons">
						<Button
							classes={['popup', 'cancel']}
							text={getText(popupsData.deleteGame.cancel, languageId)}
							onClick={() => {toggleDeleteGamePopup(null);}}
						/>
						<Button
							classes={['popup']}
							isLoading={isDeletingGame}
							text={getText(popupsData.deleteGame.delete, languageId)}
							onClick={() => {handleDeleteGame(gameId);}}
						/>
					</div>
				</div>

				
			</div>
		</div>
	);
};

DeleteGamePopup.propTypes = {
	isDeletingGame: PropTypes.bool.isRequired,
	languageId: PropTypes.string.isRequired,
	gameId: PropTypes.string,
	toggleDeleteGamePopup: PropTypes.func.isRequired,
	handleDeleteGame: PropTypes.func.isRequired,
};

export default DeleteGamePopup;
